import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { CalculatePriceComponent } from "../calculate-price/calculate-price.component";
import { GridActionsService } from "src/app/data-grid/grid-actions.service";
import { Subject } from "rxjs";
@Component({
  selector: "app-sku-price-range-grid",
  templateUrl: "./sku-price-range-grid.component.html",
  styleUrls: ["./sku-price-range-grid.component.scss", "../mini-grid.scss"],
})
export class SkuPriceRangeGridComponent implements OnInit, OnChanges,OnDestroy {
  _sku: any;
  isSidePanel: boolean;
  @Input() selectedMarkupType: any[] = [];
  @Input() get sku() {
    return this._sku;
  } 
  set sku(value) {
    this._sku = value;
  }
  @Output() editEmitter: EventEmitter<boolean> = new EventEmitter();
  @Input() selectedRow;
  markupAmount: number;
  private destroy$ = new Subject<void>();
  constructor(private dialog: MatDialog,
    private gridActionsService: GridActionsService) {
      this.isSidePanel = localStorage.getItem("toolPanel") === "true";
    }

  ngOnInit(): void {
    this.bindTooltip();
  }


  bindTooltip(){
    if(this.sku?.priceBreakdown){
      this.sku.priceBreakdown.forEach((res)=>{
        if(res.name === 'Ship Cost')
        res.tooltip="The cost of shipping this product to a customer"
       else  if( res.name ==='Cost')
        res.tooltip='The cost of this product'
        else  if(res.name ==='Prep Cost')
        res.tooltip='The cost of outbound preparation & packaging'
        else
        res.tooltip=""
      })
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.sku && this.sku.priceBreakdown) {
      const cost = this.sku.priceBreakdown.find(
        (factor) => factor.name === "Cost"
      );
      const markup = this.sku.priceBreakdown.find(
        (factor) => factor.name === "Markup"
      );
      this.markupAmount = cost.value * markup.value;
      this.bindTooltip();
    }
  }

  edit() {
    this.editEmitter.emit(true);
  }

  calculate(){
    this.dialog
      .open(CalculatePriceComponent, {
        width: "763px",
        data: {
          title: "Calculate Pricing",
          selectedSku: this.sku,
          buyBoxPrice:{
            fbaBbPrice: this.selectedRow.FbaBBPrice,
            fbmBbPrice: this.selectedRow.FbmBBPrice
          }
        },
      })
    .afterClosed()
    .subscribe((res) => {
      if(res === 'refresh') this.gridActionsService.refreshData();
    });
  }  

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
